export default __webpack_public_path__ + "static/media/mvp-runner-up.4e5ec5fd.png";